// extracted by mini-css-extract-plugin
module.exports = {"Error":"PlanDowngradeModal_Error__21iXf"};